import Ajax from '../common/ajax'
import Tool from "../common/tool";

export default {
  model: 'specialty',
  getSpecialtyList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/${this.model}/list`, queryParam)
  },
  getGradeList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/grade/list`, queryParam)
  },
  getBatchList (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/batch/list`, queryParam)
  },
  getPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/page`, queryParam)
  },
  getMockPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/mockPage`, queryParam)
  },
  getInfo (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/detail/${id}`)
  },
  getMonitorInfo (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/monitorInfo/${id}`)
  },
  copy (data = {}) {
    return Ajax.post(`/api/gradeMaster/v1/batch/copy`, data)
  },
  getAgentList (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/agent/list`, data)
  },
  getPageSetting (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/pageSetting`, data)
  },
  addSetting (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/addSetting`, data)
  },
  updateSetting (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/updateSetting`, data)
  },
  addRoom (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/addRoom`, data)
  },
  updateRoom (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/updateRoom`, data)
  },
  del (id) {
    return Ajax.del(`/api/gradeMaster/proxy/v1/evaluate/deleteRoom/${id}`)
  },
  getDetail (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/evaluate/roomDetail/${id}`)
  },
  getPageRoom (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/pageRoom`, data)
  },
  async getAgentTreeData (data = {}) {
    let agentList = await Ajax.post(`/api/gradeMaster/proxy/v1/agent/list`, data)
    let set1 = new Set()
    let set2 = new Set()
    let listAll = []
    for (let i in agentList) {
      let agent = agentList[i]
      if (!set1.has(agent.parentAddress)) {
        listAll.push({ value: agent.parentAddress, label: agent.parentAddressInfo, parentId: null })
        set1.add(agent.parentAddress)
      }
      if (!set2.has(agent.address)) {
        listAll.push({ value: agent.address, label: agent.addressInfo, parentId: agent.parentAddress })
        set2.add(agent.address)
      }
      listAll.push({ value: agent.agentId, label: agent.agentName, parentId: agent.address })
    }
    let tree = Tool.toTree(listAll, 'value', 'parentId', null, 'children')
    return tree
  },
  async getGradeTreeData (data = {}) {
    let gradeList = await Ajax.post(`/api/gradeMaster/proxy/v1/grade/list`, data)
    let set1 = new Set()
    let set2 = new Set()
    let listAll = []
    for (let i in gradeList) {
      let grade = gradeList[i]
      if (!set1.has(grade.categoryParentId)) {
        listAll.push({ value: grade.categoryParentId, label: grade.categoryParentName, parentId: null })
        set1.add(grade.categoryParentId)
      }
      if (!set2.has(grade.specialtyId)) {
        listAll.push({ value: grade.specialtyId, label: grade.specialtyName, parentId: grade.categoryParentId })
        set2.add(grade.specialtyId)
      }
      listAll.push({ value: grade.gradeId, label: grade.gradeName, parentId: grade.specialtyId })
    }
    let tree = Tool.toTree(listAll, 'value', 'parentId', null, 'children')
    return tree
  },
  getJuryList (queryParam = { pageSize: 10000, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/listJury`, queryParam)
  },
  allotUser (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/evaluate/allot/${id}`)
  },
  delayUser (data = {}) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/delayExam`, data)

  },
  resetExamTime (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/resetChooseScene/${id}`)
  },
  getEvaluateExamPage (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/pageEvaluateExam`, queryParam)
  },
  publish (data) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/publishEvaluate`, data)
  },
  getExamDetail (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/evaluate/examDetail/${id}`)
  },
  updateEvaluate (data) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/updateEvaluate`, data)
  },
  getVideoInfo (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/monitorVideo/${id}`)
  },
  getListRoom (data) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/listRoom`, data)
  },
  getChangeRoom (data) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/changeRoom`, data)
  },
  getNumberInfo (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/summary/${id}`)
  },
  ScoreEdit (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/calculate/${id}`)
  },
  getSeneList (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/grade/sceneList/${id}`)
  },
  exportExcel (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/export/${`5`}`, param)
  },
  mockExportExcel (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/export/${`8`}`, param)
  },
  ExamExportExcel (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/export/${`6`}`, param)
  },
  exportTask (key) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/lookExportTask/${key}`)
  },
  getResultUrl (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/getExamDetailUrl/${id}`)
  },
  activationExam (id) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/exam/setContinueExam/${id}`)
  },
  getTrajectory (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/trackDetail/${id}`)
  },
  getExamineeInfo (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/info/${id}`)
  },
  openRoom (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/evaluate/open/${id}`)
  },
  closeRoom (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/evaluate/close/${id}`)
  },
  publishResult (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/batchPublishEvaluate`, param)
  },
  importMusicbasisResult (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/importEvaluate`, param)
  },
  queryTask (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/common/queryTask`,param)
  },
  getMockBatchList (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/grade/sceneMockList/${id}`)
  },
  getMockDetail (id) {
    return Ajax.get(`/api/gradeMaster/proxy/v1/exam/mockDetail/${id}`)
  },
  getMusicbasisCertificate (queryParam = { pageSize: 20, pageNum: 1 }) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/pageEvaluateCertificate`, queryParam)
  },
  getMusicbasisCertificateExamResult (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/exportEvaluateCertificate`, param)
  },
  getMusicbasisCertificateExpress (param) {
    return Ajax.post(`/api/gradeMaster/proxy/v1/evaluate/exportExpressInfo`, param)
  }
}
